module.exports = "/_next/static/images/coinLogoImage-mobile-19be64e2f21fe9dded4ba097f3e6d6bc.png";